module.exports = "/_next/static/images/Hero@2x-b3e718f84109b39bd431c11ec90d74fa.png";